// extracted by css-extract-rspack-plugin
export default {"actionItem":"DefinitionDangerZone-module__actionItem__n1P0evs","divider":"DefinitionDangerZone-module__divider__Gd9gaed"};